'use client';

import { useEffect } from 'react';
// FIXME https://github.com/getsentry/sentry-javascript/issues/15209
import * as Sentry from '@sentry/nextjs';

import '@/app/globals.css';

import { FullPageLayout } from '@/app/(fullPageLayout)/layout';
import ErrorSplash from '@/app/components/ErrorSplash/ErrorSplash';

interface ErrorPageProps {
  searchParams?: Record<string, string>;
  error: Error & { digest?: string };
}

export default function Error({ error }: ErrorPageProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <FullPageLayout>
      <ErrorSplash className="px-[24px] pt-[80px] pb-[120px]" />
    </FullPageLayout>
  );
}
